import { render, staticRenderFns } from "./InvoiceRuleDetail.vue?vue&type=template&id=3cf48f9a&"
import script from "./InvoiceRuleDetail.vue?vue&type=script&lang=js&"
export * from "./InvoiceRuleDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceRuleDetail.vue?vue&type=style&index=0&id=3cf48f9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports